import { connect, batch } from 'react-redux'
import { actions } from '../../store/eventsManagement'
import { generateListCallbacks } from '../../store/helpers/listActionsHelpers'

function mapStateToProps(state) {
  return {
    events: state.eventsManagement,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    ...generateListCallbacks(dispatch, actions),
    onChangeOrder: (order) => {
      batch(() => {
        dispatch(actions.setOrder(order))
        dispatch(actions.setPagination({ page: 1 }))
      })
      return dispatch(actions.fetchList())
    },
    deleteEvent: (params) => dispatch(actions.deleteEvent(params)),
    duplicateEvent: (params) => dispatch(actions.duplicateEvent(params)),
    createEvent: (params) => dispatch(actions.createEvent(params)),
    updateEvent: (params) => dispatch(actions.updateEvent(params)),
    refetchCalendar: () => dispatch(actions.fetchCalendarEvents()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)
